import { Divider } from '@mui/material';
import DecisionTreeRouter from './DecisionTreeRouter';
import StyledBox from './styles';

function DecisionTreeWindow() {
  return (
    <>
      <Divider sx={{ marginTop: 0.5 }} />
      <Divider sx={{ marginTop: 0.25 }} />
      <StyledBox>
        <DecisionTreeRouter />
      </StyledBox>
    </>
  );
}

export default DecisionTreeWindow;
